var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video"},[(_vm.element.style.url)?_c('video',{attrs:{"controls":"","loop":true,"muted":"","autoplay":"","src":_vm.element.style.url},domProps:{"muted":true}}):_c('img',{attrs:{"src":_vm.picture,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }